import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/cdk'
    },
    {
      path: '/',
      component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
      meta: { title: 'helloFront' },
      children: [
        {
          path: '/index',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/index.vue'),
          meta: { title: '首页' }
        },
        {
          path: '/appIndex',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/appIndex.vue'),
          meta: { title: '首页' }
        },
        {
          path: '/order',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/order.vue'),
          meta: { title: '订单页' }
        },
        {
          path: '/appOrder',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/appOrder.vue'),
          meta: { title: '订单页' }
        },
        {
          path: '/cdkExchange',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/cdkExchange.vue'),
          meta: { title: '兑换码' }
        },
        {
          path: '/cdk',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/cdkExchange.vue'),
          meta: { title: '兑换码' }
        },
        {
          path: '/appCdk',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/appCdk.vue'),
          meta: { title: '兑换码' }
        },
        {
          path: '/Tutorials',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Tutorials.vue'),
          meta: { title: '防顶号' }
        },
        {
          path: '/renew',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/renew.vue'),
          meta: { title: '续费' }
        },
        {
          path: '/friend',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/friend.vue'),
          meta: { title: '添加好友' }
        },
        {
          path: '/404',
          component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
          meta: { title: '404' }
        },
        {
          path: '/403',
          component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
          meta: { title: '403' }
        }
      ]
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/register',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/register.vue'),
      meta: { title: '注册' }
    },
    {
      path: '/appLogin',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/appLogin.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/appRegister',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/appRegister.vue'),
      meta: { title: '注册' }
    },
    {
      path: '/retrievePassword',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/retrievePassword.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/appRetrievePassword',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/appRetrievePassword.vue'),
      meta: { title: '注册' }
    },
    {
      path: '/wechatLogin',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/wechatLogin.vue'),
      meta: { title: '自动登录' }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

// 判断设备类型
function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
}

// 路径映射表：键是 PC 端路径，值是移动端对应路径
const pathMap = {
  '/login': '/appLogin',
  '/register': '/appRegister',
  '/cdk': '/appCdk',
  '/cdkExchange': '/appCdk',
  '/index': '/appIndex',
  '/order': '/appOrder',
  '/retrievePassword': '/appRetrievePassword',
};

// 全局路由守卫
router.beforeEach((to, from, next) => {
  for (const [pcPath, mobilePath] of Object.entries(pathMap)) {
    if (to.path === pcPath || to.path === mobilePath) {
      if (isMobile() && to.path === pcPath) {
        console.log(`用户正在使用移动设备访问 ${pcPath}，跳转到 ${mobilePath}`);
        if (to.path === mobilePath) return next(); // 防止重复跳转
        return next(mobilePath);
      }
      if (!isMobile() && to.path === mobilePath) {
        console.log(`用户正在使用非移动设备访问 ${mobilePath}，跳转到 ${pcPath}`);
        if (to.path === pcPath) return next(); // 防止重复跳转
        return next(pcPath);
      }
    }
  }
  next(); // 继续路由
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js